/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolPermissionsSummary200,
  GetApiV1AccesscontrolPermissionsSummary401,
  GetApiV1AccesscontrolPermissionsSummary500,
  GetApiV1AccesscontrolPermissionsSummaryQueryParams,
  GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
} from "../../types/accessControlPermissionsController/GetApiV1AccesscontrolPermissionsSummary.ts";
import { roleControllerPermissionSummaryViewModelSchema } from "../roleControllerPermissionSummaryViewModelSchema.ts";

export const getApiV1AccesscontrolPermissionsSummaryQueryParamsSchema = z
  .object({
    roleId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSummaryQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolPermissionsSummary200Schema = z.array(
  z.lazy(() => roleControllerPermissionSummaryViewModelSchema),
) as unknown as ToZod<GetApiV1AccesscontrolPermissionsSummary200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolPermissionsSummary401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSummary401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolPermissionsSummary500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSummary500>;

export const getApiV1AccesscontrolPermissionsSummaryQueryResponseSchema =
  z.lazy(
    () => getApiV1AccesscontrolPermissionsSummary200Schema,
  ) as unknown as ToZod<GetApiV1AccesscontrolPermissionsSummaryQueryResponse>;
